// extracted by mini-css-extract-plugin
export default {"highlight":"D1OTbUH_SLVrxXoUMEQE","svg":"BXsQ3YIDzwbJX4p42SHW","dateJobDating":"bWW2289WYyEfIXo_Jg3K","dayBold":"_fvGxxuLLbmVeS617SXQ","downloadCVThequeLabel":"OUC903hmwo4LXNRzVFJA"};